import React from 'react';
import Select from 'react-select';
import moment from 'moment-timezone';
import { useDateTimezone } from '../Context/DateTimezoneContext';

const TimezoneSelector = ({selectedTimezone, setSelectedTimezone, placeholder}) => {
  const {setDashboardTimezone} = useDateTimezone()

  // Get a list of timezones
  const timezones = moment.tz.names().map((tz) => ({
    value: moment().tz(tz).format('z'),
    label: `${tz}`,
  }));


  // Handle change when a timezone is selected
  const handleChange = (selectedOption) => {
    setSelectedTimezone(selectedOption);
    setDashboardTimezone(selectedOption);
    console.log(`Selected timezone: ${selectedOption.label}`);
    // You can use the selected timezone as needed, for example, update state or perform some action.
  };

  return (
      <Select
        value={selectedTimezone}
        onChange={handleChange}
        options={timezones}
        isSearchable
        placeholder={placeholder}
      />
  );
};

export default TimezoneSelector;
